import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { statuses } from 'constants/booking';

import { blue, green, orange, red } from '@material-ui/core/colors';

import { withStyles } from '@material-ui/core';

const styles = {
  [statuses.PENDING]: {
    color: orange[500],
  },
  [statuses.EXPIRED]: {
    color: red[500],
  },
  [statuses.PAID]: {
    color: green[500],
  },
  [statuses.PAID_OUT]: {
    color: green[700],
  },
  [statuses.FINISHED]: {
    color: blue[500],
  },
  [statuses.CANCELLED]: {
    color: red[500],
  },
};

export const texts = {
  [statuses.PENDING]: <FormattedMessage id="pending" defaultMessage="Pending" />,
  [statuses.PAID]: <FormattedMessage id="paid" defaultMessage="Paid" />,
  [statuses.PAID_OUT]: <FormattedMessage id="paidout" defaultMessage="Paid out" />,
  [statuses.CANCELLED]: <FormattedMessage id="cancelled" defaultMessage="Cancelled" />,
  [statuses.FINISHED]: <FormattedMessage id="finished" defaultMessage="Finished" />,
  [statuses.EXPIRED]: <FormattedMessage id="expired" defaultMessage="Expired" />,
};

const longTexts = ({ paidDate, finishedDate, expireDate, cancelledDate }) => ({
  [statuses.PAID]: (
    <FormattedMessage
      id="bookingInfo.paid"
      defaultMessage="This booking was paid on {paidDate}"
      values={{ paidDate }}
    />
  ),
  [statuses.EXPIRED]: (
    <FormattedMessage
      id="bookingInfo.expired"
      defaultMessage="This booking expired on {expireDate}"
      values={{ expireDate }}
    />
  ),
  [statuses.FINISHED]: (
    <FormattedMessage
      id="bookingInfo.finished"
      defaultMessage="This booking was finished on {finishedDate}"
      values={{ finishedDate }}
    />
  ),
  [statuses.CANCELLED]: (
    <FormattedMessage
      id="bookingInfo.cancelled"
      defaultMessage="This booking was cancelled on {cancelledDate}"
      values={{ cancelledDate }}
    />
  ),
});

const getLongText = (status, isHost, expireDate, paidDate, finishedDate, cancelledDate) => {
  if (status === statuses.PENDING) {
    return isHost ? (
      <FormattedMessage
        id="bookingInfo.pendingHost"
        defaultMessage="Waiting for the guest to accept and pay, the offer expires {expireDate}"
        values={{
          expireDate,
        }}
      />
    ) : (
      <FormattedMessage
        id="bookingInfo.pendingGuest"
        defaultMessage="You have until {expireDate} to accept and pay otherwise will this offer expire"
        values={{
          expireDate,
        }}
      />
    );
  }
  return longTexts({
    expireDate,
    paidDate,
    finishedDate,
    cancelledDate,
  })[status];
};

const StatusText = ({
  classes,
  expireDate,
  paidDate,
  finishedDate,
  cancelledDate,
  isHost,
  long,
  status,
  withoutColor,
}) => (
  <span className={withoutColor ? undefined : classes[status]}>
    {long
      ? getLongText(status, isHost, expireDate, paidDate, finishedDate, cancelledDate)
      : texts[status]}
  </span>
);

StatusText.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  expireDate: PropTypes.string,
  paidDate: PropTypes.string,
  finishedDate: PropTypes.string,
  cancelledDate: PropTypes.string,
  isHost: PropTypes.bool,
  long: PropTypes.bool,
  status: PropTypes.oneOf(Object.values(statuses)).isRequired,
  withoutColor: PropTypes.bool,
};

export default withStyles(styles)(StatusText);
